import t from"@emotion/styled";import{setRadius as r,setFontSize as o,setStepperVariants as i,setColor as n}from"../../utils/generateStyles.js";const l=t.div`
  label: horizontal-step;
  display: flex;
  flex-basis: 0px;
  flex: 1 1 0%;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  position: relative;
  padding-right: 2px;
  padding-left: 2px;
  row-gap: 8px;
  ${e=>e.isDisabled&&{opacity:"0.6"}}
`,a=t.div`
  label: horizontal-step-number;
  z-index: 1;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  font-weight: 500;
  ${()=>r("full")}
  ${()=>o("xs")}
  ${e=>e.onClick&&{cursor:"pointer"}}
  ${e=>e.variant&&{color:i(e.variant).color,borderColor:i(e.variant).borderColor,backgroundColor:i(e.variant).backgroundColor}}
  @media (max-width: 768px) {
    ${()=>o("xxs")}
  }
  ${e=>e.isDisabled&&{pointerEvents:"none",cursor:"default"}};
`,s=t.div`
  label: horizontal-step-title;
  font-weight: 500;
  text-align: center;
  ${()=>o("xs")}
  ${()=>n("gray-120","color")}
  @media (max-width: 768px) {
    ${()=>o("xxs")}
  }
  ${e=>e.onClick&&{cursor:"pointer"}}
  ${e=>e.isDisabled&&{pointerEvents:"none",cursor:"default"}}
`,d=t.div`
  label: horizontal-step-connector;
  width: calc(100% - 12px);
  height: 1px;
  position: absolute;
  top: 12px;
  right: 50%;
  z-index: 0;
  pointer-events: none;
  ${e=>e.variant&&{backgroundColor:i(e.variant).connectorColor}};
  ${e=>e.number===e.lastIndex&&{display:"none"}}
`;export{d as HorizontalStepConnectorStyled,a as HorizontalStepNumberStyled,l as HorizontalStepStyled,s as HorizontalStepTitleStyled};
